import React from 'react';
import styles from "./mainTitle.module.scss";
import {AppRoutes, routeConfig} from "../../app/routeConfig";
import {Link, LinkProps} from "react-router-dom";
import {useTranslation} from 'react-i18next';

const MainTitle = () => {

  const {t, i18n} = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.titleWrap}>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{t('MainTitleTitle')}</p>
        </div>
        <div className={styles.table}>
          {/*//@ts-ignore*/}
          <p className={styles.tip}>{t('MainTitleTip')}</p>
        </div>
        <div className={styles.agreementWrap}>
        </div>
      </div>
    </div>
  );
};

export default MainTitle;